export enum ButtonPositionEnum {
  Left = 'flex-start',
  Center = 'center',
  Right = 'flex-end'
}
